<template>
  <!-- 新结算日账单 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="searchList"
        @reset="reset"
        @changeTime="(value,model)=>changeTime(value,'searchBar', 'tradeTimeStart', 'tradeTimeEnd')"
        :loading="tableLoading">
        <template slot="collectionOrder" v-if="showPos">
          <el-select v-model="searchBar.businessSource" :clearable="false" @change="changeOrder">
            <el-option v-for="(item,key) in collectionOrderOptions" :key="key" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
        <template slot="yeepay" v-if="showPos && searchBar.businessSource == 1">
          <el-select v-model="searchBar.receiveBusiness" :clearable="false">
            <el-option v-for="item in yeeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button v-if="isActiveType===3" :downloadApi="downloadBillNoOilApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" @countPoint="$track.clickEvent('结算日账单导出', '1621476350')"></download-button>
          <download-button v-else-if="isActiveType===4" :downloadApi="downloadBillVipOilApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" @countPoint="$track.clickEvent('结算日账单导出', '1621476350')"></download-button>
          <download-button v-else :downloadApi="downloadDailyBillApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" @countPoint="$track.clickEvent('结算日账单导出', '1621476350')"></download-button>
          <template v-if="isActiveType !== 3 && isActiveType !== 4">
            <el-button size="mini" @click="gotoOldBill">8月4日前日账单 >>></el-button>
          </template>
        </template>
      </mer-search>
    </el-card>
    <dayBillPosTab :isGas="isGas" :showPos="showPos" @handleChangeType="handleChangeType" :isActiveType="isActiveType" :sumInfoAll="sumInfoAll" :sumTuanInfoData="sumTuanInfoData" :posSumInfoData="posSumInfoData" :sumFeiTuanInfoData="sumFeiTuanInfoData" :sumVipInfoData="sumVipInfoData" :hasUnOil="hasUnOil" :settlementDisplayType="settlementDisplayType"></dayBillPosTab>
    <!-- <dayBillPosTab :isGas="isGas" :showPos="true" @handleChangeType="handleChangeType" :isActiveType="isActiveType" :sumInfoAll="sumInfoAll" :sumTuanInfoData="sumTuanInfoData" :posSumInfoData="posSumInfoData" :sumFeiTuanInfoData="sumFeiTuanInfoData" :hasUnOil="hasUnOil"></dayBillPosTab> -->
    <el-card class="order-card" shadow="never" :body-style="{ padding: '0'}" style="margin-top: 20px;border: none">
      <!-- 非油列表 -->
      <template v-if="isActiveType === 3">
        <el-table v-loading="loading" size="small" :data="unOilTableData"  highlight-current-row border  style="width: 100%">
          <el-table-column v-for="(item, index) in otherConfig" :key="index" :prop="item.prop" :width="item.width" :label="item.label" :align="item.align"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="unOilPagination.pageIndex"
          :page-sizes="pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="unOilTotal"
          class="tablePagination">
        </el-pagination>
      </template>
      <template v-else-if="isActiveType === 4">
        <el-table v-loading="loading" size="small" :data="vipTableData"  highlight-current-row border  style="width: 100%">
          <el-table-column v-for="(item, index) in vipConfig" :key="index" :prop="item.prop" :width="item.width" :label="item.label" :align="item.align"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageIndex"
          :page-sizes="pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="vipTotal"
          class="tablePagination">
        </el-pagination>
      </template>
      <!-- 团油列表 -->
      <template v-else>
        <el-table v-loading="loading" size="small" :data="tableData"  highlight-current-row border  style="width: 100%">
          <el-table-column v-for="(item, index) in isPosTable ? posConfig : tableConfig" :key="index" :prop="item.prop" :width="item.width" :label="item.label" :align="item.align"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageIndex"
          :page-sizes="pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="tablePagination">
        </el-pagination>
      </template>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import dayBillPosTab from './components/bill/dayBillPosTab'
import { getDailyBillSummaryApi, getDailyBillListApi, downloadDailyBillApi, downloadBillNoOilApi, downloadBillVipOilApi ,getHasPosRightInHistory, receiveBusinessList, getVipList, getWhetherSimpleApi, querySettlementMethodList } from '@/api/finance'
import { getStationEnergyType } from '@api/common'
import { getHasUnOil, nonOilList, nonOilSummary } from '@/api/finance/nonOil'
import { mapState, mapGetters } from 'vuex'

const billStatusList = [
  {
    label: '已生成',
    value: '10'
  },
  {
    label: '已勾销',
    value: '30'
  },
    {
    label: '无需结算',
    value: '50'
  },
  {
    label: '关闭付款',
    value: '40'
  },
]

  // 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '账单日期', type: 'date', modelName: 'tradeTime', model: '', dateType: 'daterange', format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false},
  { label: '账单状态', type: 'select', modelName: 'billStatus', placeholder: '全部', selectOptions: billStatusList, define: true, selectLabel: 'label', selectValue: 'value' },
  { label: '收单方式', type:'slot', slotName: 'collectionOrder'},
  { label: '结算方', type:'slot', slotName: 'yeepay'},
  { label: '结算周期', type: 'select', modelName: 'settlementCycle', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'desc', selectValue: 'code', clearable: true},
]
// 表格参数配置
let tableConfig = [
  { label: '账单日期', prop: 'settlementDate', slot:'settlementDate', width: 150 },
  { label: '油站名称', prop: 'gasName', width: 136  },
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '加油金额(元)', prop: 'amountGun', width: 136 },
  { label: '让利金额(元)', prop: 'amountRebate', width: 136},
  { label: '应结算金额(元)', prop: 'billAmount', width: 136 },
  { label: '通道费金额(元)', prop: 'slottingFee', width: 136 },
  { label: '商家承担营销总金额(元)', prop: 'merchantTotalMarketingAmount', width: 156 },
  { label: '商家承担直降金额', prop: 'amountActivityMerchant', width: 136 },
  { label: '商家承担平台优惠券金额', prop: 'amountPlatformCouponMerchant', width: 156 },
  { label: '商家承担商家优惠券金额', prop: 'merchantCouponAmount', width: 156},
  { label: '商户优惠券售卖金额', prop: 'merchantVoucher', width: 156},
  { label: '商家权益卡优惠总金额(元)', prop: 'mctProfitMctAmount', width: 156},
  { label: '商家承担增长计划总金额(元)', prop: 'merchantGrowthPlanAmount', width: 136 },
  { label: '商家承担点金计划总金额(元)', prop: 'merchantJubaoPlanAmount', width: 136 },
  { label: '商家承担锁客宝总金额(元)', prop: 'merchantCustLockAmount', width: 136 },
  { label: '商家承担营销折扣总金额(元)', prop: 'merchantMktDiscountAmount', width: 136 },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount', width: 136 },
  { label: '消费升数', prop: 'litre' },
  { label: '交易笔数', prop: 'tradeCount' },
  { label: '通道费周期', prop: 'settlementCycleName',width: 136 },
  { label: '账单状态', prop: 'billStatusName',width: 136 },
  { label: '账单生成时间', prop: 'createTime',width: 150 },
  { label: '活动让利金额', prop: 'couponTwoActivityRebate',width: 150 },
  { label: '商户承担活动补贴成本', prop: 'merchantCouponTwoActivityAmount',width: 150 }
]

// pos参数配置
let posConfig = [
  { label: '账单日期', prop: 'settlementDate', slot:'settlementDate', width: 150 },
  { label: '油站名称', prop: 'gasName', width: 136  },
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '加油金额(POS收单)', prop: 'amountGun', width: 136 },
  { label: '应结算金额(POS收单)', prop: 'billAmount', width: 136 },
  { label: '通道费金额(POS收单)', prop: 'slottingFee', width: 136 },
  { label: '实际结算金额(POS收单)', prop: 'realSettlementAmount', width: 136 },
  { label: '结算方', prop: 'receiveBusinessName', width: 136 },
  { label: '消费升数(POS收单)', prop: 'litre' },
  { label: '交易笔数(POS收单)', prop: 'tradeCount' },
  { label: '通道费周期', prop: 'settlementCycleName',width: 136 },
  { label: '账单状态', prop: 'billStatusName',width: 136 },
  { label: '账单生成时间', prop: 'createTime',width: 150 }
]

// 非油品参数配置
let otherConfig = [
  { label: '账单日期', prop: 'billDate', slot:'billDate' },
  { label: '油站名称', prop: 'gasName' },
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '订单数（笔）', prop: 'orderBillNum' },
  { label: '应结算金额(元)', prop: 'shouldAmount' },
  { label: '实际结算金额(元)', prop: 'settlementAmount' },
  { label: '账单状态', prop: 'billStatus' },
  { label: '账单生成时间', prop: 'createDate' }
]

// 会员卡参数配置
let vipConfig = [
  { label: '账单日期', prop: 'billDate' },
  { label: '油站名称', prop: 'gasName'},
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '订单金额（元）', prop: 'tradeAmount' },
  { label: '应结算金额(元)', prop: 'settlementAmount' },
  { label: '手续费(元)', prop: 'serviceFee' },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount' },
  { label: '状态', prop: 'payState' }
]

// const isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))

export default {
  name: 'bill_dailyBill',
  mixins:[ listPage, queryMix ],
  components: { dayBillPosTab },
  data(){
    return{
      downloadDailyBillApi,
      downloadBillNoOilApi,
      downloadBillVipOilApi,
      isGas: null, // 是否是加气。 1-油 2-气 3-油气
      isPosTable: false,
      showPos: false,
      tradeTime:'',
      formConfig,
      tableConfig, // 团油表格
      posConfig, // pos 表格
      vipConfig, // 会员表格
      otherConfig,
      tableData: [],
      unOilTableData: [],
      vipTableData: [],
      isActiveType: 0, // tab切换
      sumInfoAll: {}, // 总汇总信息
      sumTuanInfoData: {}, // 团油收单汇总
      sumFeiTuanInfoData: {}, // 非油品收单汇总
      posSumInfoData: {}, // pos收单汇总
      sumVipInfoData: {}, // 会员卡收单汇总
      loading: false,
      gasInfo: [],
      pagination: {
        pageIndex: 1,
        pageSize: 20
      },
      unOilPagination: {
        pageIndex: 1,
        pageSize: 20
      },
      vipPagination: {
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      unOilTotal: 0,
      vipTotal: 0,
      pageSizes: [20],
      searchBar: { businessSource: 0, receiveBusiness: null },
      collectionOrderOptions: [],
      yeeOptions: [],
      hasUnOil: false,
      settlementDisplayType: 4, // 1：完整版 2：截流简单版 3:截流不简单版 4:旧版
    }
  },
  async created(){
    this.collectionOrderOptions.push(...[{ label: `${this.platformName}收单`, value: 0 }, { label: 'POS收单', value: 1 }])
    this.$track.pageViewEvent('结算日账单', '1621476345')
    this.queryEnum()
    await this.checkUnOil()
    this.initPage()
    this.getHasPosRightInHistoryApi()
    this.getWhetherSimple()
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters(['platformName'])
  },
  methods:{
    async queryEnum() {
      const { code, result } = await querySettlementMethodList()
      if (code !== 200) return
      const item = this.formConfig.find(item => item.modelName === 'settlementCycle')
      item && (item.selectOptions = result)
    },
    // 获取完整版还是截流简单版
    async getWhetherSimple () {
      const { code, result } = await getWhetherSimpleApi()
      if (code !== 200) return
      this.settlementDisplayType = result.settlementDisplayType
      if (this.settlementDisplayType === 2 || this.settlementDisplayType === 3) {
        const hideParams = ['merchantGrowthPlanAmount', 'merchantJubaoPlanAmount', 'merchantCustLockAmount', 'merchantMktDiscountAmount', 'amountRebate', 'amountActivityMerchant', 'amountPlatformCouponMerchant', 'merchantCouponAmount', 'mctProfitMctAmount', 'billAmount']
        hideParams.map(subItem => {
          const i = this.tableConfig.findIndex(item => item.prop === subItem)
          if (i !== -1) {
            this.tableConfig.splice(i, 1)
          }
        })
      } else if (this.settlementDisplayType === 1) {
        const i = this.tableConfig.findIndex(item => item.prop === 'merchantTotalMarketingAmount')
        if (i !== -1) {
          this.tableConfig.splice(i, 1)
        }
      } else {
        const hideParams = ['merchantGrowthPlanAmount', 'merchantCustLockAmount', 'merchantJubaoPlanAmount', 'merchantMktDiscountAmount', 'merchantTotalMarketingAmount']
        hideParams.map(subItem => {
          const i = this.tableConfig.findIndex(item => item.prop === subItem)
          if (i !== -1) {
            this.tableConfig.splice(i, 1)
          }
        })
      }
    },
    async checkUnOil () {
      let { code, result } = await getHasUnOil()
      if (code !== 200) return
      this.hasUnOil = result
    },
    initPage () {
      this.initQuery()
      this.getAllGasStations()
      // this.receiveBusinessListApi()
      this.refresh()
    },  
    // 重置，设置默认查询条件，默认时间间隔7天
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 6, 'searchBar',true, 'tradeTimeStart', 'tradeTimeEnd')
      const { tradeTime, pickerOptions } = this
      const initObj = { tradeTime: [tradeTime, pickerOptions] }
      this.setSearchConfig(initObj)
      this.formConfig = this.formConfig.filter(item => item.slotName !== 'yeepay')
      // this.searchBar.receiveBusiness = null // 团油不传结算方式参数
    },
    // 切换收单方式, 结算方查询条件是否展示
    changeOrder (val) {
      this.isActiveType = val
      const yeepay = { label: '结算方', type:'slot', slotName: 'yeepay'}
      if (val === 1) {
        const index = this.formConfig.findIndex(item => item.modelName === 'settlementCycle')
        this.formConfig.splice(index, 0, yeepay)
        this.searchBar.receiveBusiness = '2'
      } else {
        let index = this.formConfig.findIndex(item => item.slotName === 'yeepay')
        if (index !== -1) {
          this.formConfig.splice(index, 1)
        }
        this.searchBar.receiveBusiness = null
      }
      this.refresh()
    },
    // 字传父切换
    handleChangeType (val) {
      this.isActiveType = val
      this.pagination.pageIndex = 1
      let index = this.formConfig.findIndex(item => item.slotName === 'collectionOrder')
      let collectionOrder = { label: '收单方式', type:'slot', slotName: 'collectionOrder'}
      const billStatusIndex = this.formConfig.findIndex(item => item.modelName === 'billStatus')
      if (billStatusIndex === -1) this.formConfig.push({ label: '账单状态', type: 'select', modelName: 'billStatus', placeholder: '全部', selectOptions: billStatusList, define: true, selectLabel: 'label', selectValue: 'value' })
      if (val === 3) {
        this.formConfig = this.formConfig.filter(item => item.slotName !== 'collectionOrder' && item.slotName !== 'yeepay')
        this.searchBar.businessSource = null
        this.searchBar.receiveBusiness = null
        if (this.searchBar.billStatus == 20) this.searchBar.billStatus = '10'
      } else if (val === 4) {
        this.formConfig = this.formConfig.filter(item => item.modelName !=='billStatus' && item.slotName !== 'collectionOrder' && item.slotName !== 'yeepay')
        this.searchBar.businessSource = null
        this.searchBar.receiveBusiness = null
        this.searchBar.billStatus = ''
        let gasName = this.gasInfo.length && this.searchBar.gasId ? this.gasInfo.filter(item => item.gasId === this.searchBar.gasId)[0].gasName : ''
        const data = { ...this.searchBar, ...this.pagination, gasName }
        this.searchVipList(data)
      } else if (this.showPos && index === -1) {
        this.formConfig.push(collectionOrder)
      }
    },
    // 每页多少天改变时
    handleSizeChange (val) {
      console.log(val)
    },
    // 切换分页
    handleCurrentChange (val) { // 翻页
      this.pagination.pageIndex = val
      this.refresh()
    },
    //导出
    download () {
      this.$track.clickEvent('结算日账单导出', '1621476350')
      this.downloadFile(downloadDailyBillApi,'结算日账单')
    },
    gotoOldBill(){
      this.$track.clickEvent('结算日账单历史账单查询', '1622197876')
      this.$router.push({path:'/bill/oldDailyBill'})
    },
    // 查询条件重置
    reset (initQuery, searchName = 'searchBar') {
      this.$track.clickEvent('结算日账单重置', '1621476351')
      this.isActiveType = 0
      this.$data[searchName] = { receiveBusiness: undefined }
      this.searchBar.businessSource = this.showPos ? 0 : null // 重置，收单方式默认团油收单
      this.initQuery()
      this.search()
    },
    searchList () {
      this.$track.clickEvent('结算日账单查询', '1621476347')
      this.$track.clickEvent('结算日账单时间选择', '1621476348', {
        tysj_start_time: this.searchBar.tradeTimeStart,
        tysj_end_time: this.searchBar.tradeTimeEnd
      })
      this.$track.clickEvent('结算日账单账单状态', '1621476349', {
        tysj_trade_type: this.searchBar.billStatus
      })
      this.$track.clickEvent('结算日账单收单方式', '1621476400', {
        tysj_trade_type: this.searchBar.businessSource
      })
      this.$track.clickEvent('结算日账单油站', '1621476401')
      this.search()
    },
    // 查找目标表格索引
    findColumnIndex (key, table) {
      return this[table].findIndex(item => item.prop === key)
    },
    // 判断是否存在pos
    async getHasPosRightInHistoryApi() {
      try {
        const { code, result } = await getHasPosRightInHistory()
        if(code !== 200) return
        this.showPos = result
        if (result) {
          this.receiveBusinessListApi()
        } else {
          this.formConfig = this.formConfig.filter(item => item.slotName !== 'collectionOrder')
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination }
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar }
      let gasName = this.gasInfo && this.gasInfo.length && this.searchBar.gasId ? this.gasInfo.filter(item => item.gasId === this.searchBar.gasId)[0].gasName : ''
      this.getSumInfo({ ...data, gasName })
      if (this.hasUnOil) {
        this.getUnOilSumInfo(data)
      }
      // 判断是否是加气的站, 商户调取接口，需要传gasId,否则默认给油站数据，油站调取接口不需要传参
      if (!this.userInfo.company) {
        this.getStationEnergyTypeApi()
      } else {
        this.getStationEnergyTypeApi({ gasId: data.gasId })
      }
      // 如果有非油权限，查询非油数据
      if (this.hasUnOil) {
        this.searchUnOilList(data)
      }
      if (this.isActiveType === 4) {
        this.searchVipList({ ...data, gasName })
      }
      try{
        this.isPosTable = data.businessSource !== 0
        const { code, result = [], totalRow = 0 } = await getDailyBillListApi(data)
        if(code !== 200) return
        this.tableData = result
        this.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 查询非油列表
    async searchUnOilList (data) {
      const { code, result, totalRow = 0 } = await nonOilList(data)
      if (code !== 200) return
      this.unOilTableData = result
      this.unOilTotal = parseInt(totalRow)
    },
    // 会员卡收单汇总列表
    async searchVipList (data) {
      const { code, result, totalRow = 0 } = await getVipList(data)
      if (code !== 200) return
      this.vipTableData = result
      this.vipTotal = parseInt(totalRow)
    },
    // 列表汇总（统计）信息
    async getSumInfo (data) {
      console.log(data)
      try{
        const { code, result } = await getDailyBillSummaryApi(data)
        if(code !== 200) return
        const { posDailyBillSummary, appDailyBillSummary, memberDailyBillSummary } = result
        this.sumInfoAll = result || {}
        this.sumTuanInfoData = appDailyBillSummary || {} // 团油收单汇总
        this.posSumInfoData = posDailyBillSummary || {} // pos收单汇总
        this.sumVipInfoData = memberDailyBillSummary || {} // 会员卡
      }catch(err){
        console.log(err)
      }
    },
    // 非油汇总信息
    async getUnOilSumInfo (data) {
      try{
        const { code, result } = await nonOilSummary(data)
        if(code !== 200) return
        this.sumFeiTuanInfoData = result
      }catch(err){
        console.log(err)
      }
    },
    // 判断当前油站是加气还是加油
    async getStationEnergyTypeApi (params) {
      try {
        const { code, result } = await getStationEnergyType(params)
        if(code !==200) return
        this.isGas = result
        this.tableConfig[this.findColumnIndex('litre', 'tableConfig')].label = result === 2 ? '数量' : '升数'
        this.tableConfig[this.findColumnIndex('amountGun', 'tableConfig')].label = result === 2 ? '金额（元）' : '加油金额（元）'
        this.posConfig[this.findColumnIndex('litre', 'posConfig')].label = result === 2 ? '数量(POS收单)' : '升数(POS收单)'
        this.posConfig[this.findColumnIndex('amountGun', 'posConfig')].label = result === 2 ? '金额(POS收单)' : '加油金额(POS收单)'
      } catch (error) {
        console.log(error)
      }
    },
    // 结算方式枚举
    async receiveBusinessListApi () {
      try {
        let { code, result: { receiveBusiness } } = await receiveBusinessList()
        if(code !== 200) return
        this.yeeOptions = Object.entries(receiveBusiness).map(itemArr => ({ value: itemArr[0], label: itemArr[1] }))
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.tablePagination{
  margin: 15px 0;
  float: right;
}
</style>
